import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_intersection_trigger = _resolveComponent("intersection-trigger")

  return (_openBlock(), _createBlock(_component_intersection_trigger, _mergeProps({ threshold: $props.threshold, root: $props.root, rootMargin: $props.rootMargin }, { onIntersected: $options.onIntersected }), {
    default: _withCtx(() => [
      _createElementVNode("div", _mergeProps({ class: "_tac _pt-1" }, _ctx.$attrs), [
        _renderSlot(_ctx.$slots, "default")
      ], 16 /* FULL_PROPS */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["onIntersected"]))
}